import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ContactTypeEnums } from 'src/app/enum/contact-type-enums';
import { TypePersonEnums } from 'src/app/enum/type-person-enums';
import { ProviderModel } from 'src/app/models/archive/provider.model';
import { CityTableModalModel } from 'src/app/models/management/city-table-modal.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ClientService } from 'src/app/services/archive/client.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ProviderService } from '../../../../services/archive/provider.service';
import { ContactReferenceModalComponent } from '../../contact-reference-modal/contact-reference-modal.component';
import { UpdateDocumentProviderComponent } from '../update-document-provider/update-document-provider.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-register-provider',
  templateUrl: './register-provider.component.html',
  styleUrls: ['./register-provider.component.scss'],
  standalone: false
})
export class RegisterProviderComponent implements OnInit, OnDestroy {

  @ViewChild('selectCity') citySelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('changeDocumentModal') changeDocumentModalComponent?: CustomModalComponent | null = null;
  @ViewChild('contactModal') contactModalComponent?: CustomModalComponent | null = null;

  ascendant: boolean = true;
  cityId: number = 0;
  cityName: string = '';
  citySelectionData: PagedResponseModel<CityTableModalModel> = new PagedResponseModel<CityTableModalModel>();
  columnSort: string | null = null;
  componentChangeDocumentModal = UpdateDocumentProviderComponent;
  componentCitySelection = CustomTableSelectComponent;
  componentContactModal = ContactReferenceModalComponent;
  departmentId: number = 0;
  departmentName: string = '';
  disabledForm: boolean = false;
  disableUpdateDocument: boolean = false;
  filtersCitySelection: ColumnResponseModel[] = [];
  formProvider: FormGroup = new FormGroup({});
  headersCitySelection: ColumnResponseModel[] = [];
  inputsForChangeDocumentModals$ = new BehaviorSubject<any>({ providerId: 0 });
  inputsForContactModals$ = new BehaviorSubject<any>({
    entityId: 0,
    isContact: false,
    typeContact: 0
  });
  inputsForSelectCityModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: true,
    showRecover: true
  });
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listCurrency: any[] = [];
  listProviderState: any[] = [{ label: 'Activo', value: true }, { label: 'Inactivo', value: false }];
  listTypeDocument: any[] = [];
  listTypePerson: any[] = [];
  nameWindow: string = 'Captura Proveedores';
  output$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  providerContract: ProviderModel = new ProviderModel();
  providerId: number = 0;
  subscription: Subscription;
  subscriptionGeneralParameter?: Subscription;
  swPurchaseModule: boolean = false;
  typeContact: number = ContactTypeEnums.provider;
  url: string = "provider";
  visibleGreatContributor: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private clientService: ClientService,
    private formBuilder: FormBuilder,
    private confirmDialogService: ConfirmDialogService,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private providerService: ProviderService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.providerContract);
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.providerId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCity(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCity(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    } else {
      localStorage.clear();
    }
    this.subscription?.unsubscribe();
    this.subscriptionGeneralParameter?.unsubscribe();
  }

  async changeDocument() {
    const typeDocumentId = this.formProvider.get("typeDocumentId")?.value;
    const document = this.formProvider.get("document")?.value;
    if (document != "") {
      await this.getProviderByDocument(document, typeDocumentId);
    } else {
      this.createNewProvider();
    }
  }

  changeIvaResponsible() {
    const swIvaResponsible = this.formProvider.get("swIvaResponsible")?.value;
    const swSimpleTaxRegime = this.formProvider.get("swSimpleTaxRegime")?.value;
    if (swIvaResponsible && !swSimpleTaxRegime) {
      this.visibleGreatContributor = true;
    } else {
      this.visibleGreatContributor = false;
      this.formProvider.controls["swGreatContributor"].patchValue(false);
      this.formProvider.controls["swIvaRetainer"].patchValue(false);
      this.formProvider.controls["swSelfRetainer"].patchValue(false);
    }
  }

  changeNames() {
    let names = this.formProvider.get("names")?.value;
    let lastNames = this.formProvider.get("lastNames")?.value;
    if (names == null) {
      names = '';
    } else if (lastNames == null) {
      lastNames = '';
    }
    this.formProvider.controls["businessName"].patchValue(`${names} ${lastNames}`);
  }

  // async changeState(providerState: any) {
  //   if (this.providerContract.providerId != 0 && this.providerContract.providerId != null) {
  //     if (this.permissionUpdatable) {
  //       const result = await Swal.fire({
  //         title: 'Atención',
  //         text: '¿Realmente desea cambiar el estado del proveedor?',
  //         icon: 'question',
  //         showCancelButton: true,
  //         confirmButtonColor: '#3085d6',
  //         cancelButtonColor: '#d33',
  //         confirmButtonText: 'Si',
  //         cancelButtonText: 'No'
  //       });
  //       if (result.isConfirmed) {
  //         try {
  //           this.providerContract = await firstValueFrom(this.providerService.setActiveProvider(this.providerId));
  //           if (this.providerContract.active) {
  //             this.toastHandlerService.showToast(
  //               'success',
  //               'El proveedor fue activado exitosamente.'
  //             );
  //           } else {
  //             this.toastHandlerService.showToast(
  //               'success',
  //               'El proveedor fue inactivado exitosamente.'
  //             );
  //           }
  //           this.validateForm(this.providerContract);
  //         } catch (error) {
  //           console.error('Error al cambiar el estado del proveedor.', error);
  //         }
  //       } else {
  //         this.formProvider.controls["active"].patchValue(!providerState as boolean);
  //       }
  //     } else {
  //       this.formProvider.controls["active"].patchValue(!providerState as boolean);
  //       this.toastHandlerService.showToast(
  //         'error',
  //         'El usuario no tiene permisos para modificar proveedores. Comuníquese con el administrador del sistema.'
  //       );
  //     }
  //   } else {
  //     this.formProvider.controls["active"].patchValue(!providerState as boolean);
  //     this.toastHandlerService.showToast(
  //       'warning',
  //       'Debe crear un proveedor.'
  //     );
  //   }
  // }

  async changeState(providerState: any) {
    if (this.providerContract.providerId == 0 || this.providerContract.providerId == null) {
      this.formProvider.controls["active"].patchValue(!providerState as boolean);
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un proveedor.'
      );
      return;
    }

    if (!this.permissionUpdatable) {
      this.formProvider.controls["active"].patchValue(!providerState as boolean);
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para modificar proveedores. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    if (!(await this.confirmDialogService.confirm('¿Realmente desea cambiar el estado del proveedor?'))) {
      this.formProvider.controls["active"].patchValue(!providerState as boolean);
      return;
    }

    try {
      this.providerContract = await firstValueFrom(this.providerService.setActiveProvider(this.providerId));
      if (this.providerContract.active) {
        this.toastHandlerService.showToast(
          'success',
          'El proveedor fue activado exitosamente.'
        );
      } else {
        this.toastHandlerService.showToast(
          'success',
          'El proveedor fue inactivado exitosamente.'
        );
      }
      this.validateForm(this.providerContract);
    } catch (error) {
      console.error('Error al cambiar el estado del proveedor.', error);
    }
  }

  changeTypePerson(typePersonId: number) {
    this.disableNamesByTypePerson(typePersonId);
    if (typePersonId == TypePersonEnums.natural) {
      this.formProvider.controls["businessName"].patchValue(null);
    } else if (typePersonId == TypePersonEnums.juridica) {
      this.formProvider.controls["names"].patchValue(null);
      this.formProvider.controls["lastNames"].patchValue(null);
    }
  }

  createNewProvider() {
    if (this.permissionUpdatable) {
      this.providerContract = new ProviderModel();
      this.providerId = this.providerContract.providerId;
      this.departmentName = "";
      this.cityName = "";
      this.disableUpdateDocument = true;
      this.validateForm(this.providerContract);
      this.location.replaceState(`/provider/register`);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear proveedores. Comuníquese con el administrador del sistema.'
      );
    }
  }

  // async deleteProvider() {
  //   if (this.providerContract.providerId != 0 && this.providerContract.providerId != null) {
  //     if (this.permissionUpdatable) {
  //       const result = await Swal.fire({
  //         title: 'Atención',
  //         text: `¿Realmente desea eliminar al proveedor ${this.providerContract.businessName}?`,
  //         icon: 'question',
  //         showCancelButton: true,
  //         confirmButtonColor: '#3085d6',
  //         cancelButtonColor: '#d33',
  //         confirmButtonText: 'Si',
  //         cancelButtonText: 'No'
  //       });
  //       if (result.isConfirmed) {
  //         try {
  //           await firstValueFrom(this.providerService.deleteProvider(this.providerId));
  //           this.toastHandlerService.showToast(
  //             'success',
  //             'El proveedor fue eliminado exitosamente.'
  //           );
  //           this.createNewProvider();
  //         } catch (error) {
  //           console.error('Error al eliminar el proveedor.', error);
  //         }
  //       }
  //     } else {
  //       this.toastHandlerService.showToast(
  //         'error',
  //         'El usuario no tiene permisos para eliminar proveedores. Comuníquese con el administrador del sistema.'
  //       );
  //     }
  //   } else {
  //     this.toastHandlerService.showToast(
  //       'warning',
  //       'Debe crear un proveedor.'
  //     );
  //   }
  // }

  async deleteProvider() {
    if (this.providerContract.providerId == 0 || this.providerContract.providerId == null) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un proveedor.'
      );
      return;
    }

    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para eliminar proveedores. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    if (!(await this.confirmDialogService.confirm(`¿Realmente desea eliminar al proveedor ${this.providerContract.businessName}?`))) {
      return;
    }

    try {
      await firstValueFrom(this.providerService.deleteProvider(this.providerId));
      this.toastHandlerService.showToast(
        'success',
        'El proveedor fue eliminado exitosamente.'
      );
      this.createNewProvider();
    } catch (error) {
      console.error('Error al eliminar el proveedor.', error);
    }
  }

  disableNamesByTypePerson(typePersonId: number) {
    if (typePersonId == TypePersonEnums.natural) {
      setTimeout(() => {
        this.formProvider.controls["names"].enable();
        this.formProvider.controls["lastNames"].enable();
        this.formProvider.controls["businessName"].disable();
      }, 100);
    } else if (typePersonId == TypePersonEnums.juridica) {
      setTimeout(() => {
        this.formProvider.controls["names"].disable();
        this.formProvider.controls["lastNames"].disable();
        this.formProvider.controls["businessName"].enable();
      }, 100);
    }
  }

  async getAllCitySelectionAsync() {
    try {
      this.citySelectionData = await firstValueFrom(
        this.clientService.getCitiesAsync(
          this.page, this.limit, this.columnSort, this.ascendant, this.filtersCitySelection
        )
      );
      this.updateInputsForSelectCityModal();
    } catch (error) {
      console.error('Error obteniendo ciudades para el modal.', error);
    }
  }

  async getAllLists() {
    try {
      const [typeDocuments, typePersons, currencies] = await Promise.all([
        firstValueFrom(this.clientService.getAllTypeDocumentsForSelectAsync()),
        firstValueFrom(this.clientService.getAllTypePersonsForSelectAsync()),
        firstValueFrom(this.clientService.getAllCurrenciesForSelectAsync()),
      ]);

      this.listTypeDocument = typeDocuments;
      this.listTypePerson = typePersons;
      this.listCurrency = currencies;

      return true;
    } catch (error) {
      console.error('Error obteniendo listas.', error);
      return false;
    }
  }

  async getCityDepartment(cityId: number) {
    try {
      const cityDepartment: any = await firstValueFrom(this.clientService.getCityDepartment(cityId));
      this.cityName = cityDepartment.cityName;
      this.departmentName = cityDepartment.departmentName;
    } catch (error) {
      this.cityName = '';
      this.departmentName = '';
      console.error('Error al obtener la ciudad y el departamento.', error);
    }
  }

  async getColumnsCitySelection() {
    try {
      if (this.headersCitySelection.length === 0) {
        this.headersCitySelection = await firstValueFrom(this.clientService.getColumnsForCitiesAsync());
      }
    } catch (error) {
      console.error('Error al buscar las columnas de ciudad para el modal.', error);
    }
  }

  getGeneralParametersByCompany() {
    this.subscriptionGeneralParameter = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swPurchaseModule = response.some(x => x.name === GeneralParameters.purchaseModule);
    });
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getPermissionProfileByUrl();
    await this.getAllLists();
    this.getGeneralParametersByCompany();
    this.inputsForChangeDocumentModals$.next({ providerId: this.providerContract.providerId });
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por perfil.', error);
    }
  }

  async getProviderByDocument(document: string, typeDocumentId: number) {
    try {
      this.providerContract = await firstValueFrom(this.providerService.getProviderByDocumentAsync(document));
      this.providerId = this.providerContract.providerId;
      this.validateForm(this.providerContract);
      if (this.providerId === 0) {
        this.formProvider.controls["typeDocumentId"].patchValue(typeDocumentId);
        setTimeout(() => this.formProvider.controls["businessName"].disable(), 100);
      }
      if (this.providerContract.providerId === 0) {
        this.location.replaceState(`/provider/register`);
      } else {
        this.location.replaceState(`/provider/register/${this.providerId}`);
      }
    } catch (error) {
      this.formProvider.controls["digitVerification"].patchValue(-1);
      console.error('Error al obtener el proveedor por documento.', error);
    }
  }

  async getProviderById() {
    try {
      this.providerContract = await firstValueFrom(this.providerService.getProviderById(this.providerId));
      this.validateForm(this.providerContract);
    } catch (error) {
      console.error('Error al obtener el proveedor por ID:', error);
    }
  }

  handleInitialState() {
    if (this.providerId !== null && this.providerId !== 0) {
      this.getProviderById();
    } else {
      this.createNewProvider();
    }
  }

  async onFilterChangeCity(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersCitySelection = this.removeDuplicates(filters);
    this.filtersCitySelection.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForSelectCityModal();
  }

  async onPageChangeCity(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllCitySelectionAsync();
  }

  async openCitySelectionModal() {
    if (this.providerContract.active) {
      this.filtersCitySelection = [];
      await Promise.all([
        this.getColumnsCitySelection(),
        this.getAllCitySelectionAsync()]
      );
      this.updateInputsForSelectCityModal();
      this.citySelectionModalComponent && this.citySelectionModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Para modificar la ciudad, el proveedor debe estar activo.'
      );
    }
  }

  openChangeDocumentModal() {
    if (this.providerContract.providerId != 0 && this.providerContract.providerId != null) {
      this.changeDocumentModalComponent && this.changeDocumentModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un proveedor.'
      );
    }
  }

  openContactModal() {
    this.inputsForContactModals$.next({ entityId: this.providerContract.providerId, typeContact: this.typeContact, isContact: true });
    if (this.providerContract.providerId != 0 && this.providerContract.providerId != null) {
      this.contactModalComponent && this.contactModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un proveedor.'
      );
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersCitySelection = this.filtersCitySelection.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersCitySelection.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async reloadProvider(reload: boolean) {
    if (reload) {
      await this.getProviderById();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    Object.keys(this.formProvider.controls).forEach(key => {
      const control = this.formProvider.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.cityId === 0 || this.departmentId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        `El campo Ciudad y Departamento son obligatorios.`);
      return;
    }

    //válido que hayan seleccionado una de las opciones de provee
    if (!this.formProvider.get("shopping")?.value && !this.formProvider.get("subRent")?.value && !this.formProvider.get("transport")?.value) {
      this.toastHandlerService.showToast(
        'warning',
        'No se ha definido "Que provee", seleccione al menos un item para continuar.'
      );
      return;
    }

    if (this.formProvider.valid) {
      //Hago enable los campos de nombres para que me permita guardarlos:
      this.formProvider.controls['names'].enable();
      this.formProvider.controls['lastNames'].enable();
      this.formProvider.controls['businessName'].enable();
      this.formProvider.controls['digitVerification'].enable();
      const modelProvider = this.formProvider.value as ProviderModel;
      modelProvider.cityId = this.cityId;
      modelProvider.departmentId = this.departmentId;
      //Hago null, los campos que permiten ser nulos:
      if (modelProvider.names?.trim() === "") modelProvider.names = null;
      if (modelProvider.lastNames?.trim() === "") modelProvider.lastNames = null;
      if (modelProvider.comercialName?.trim() === "") modelProvider.comercialName = null;
      if (modelProvider.email?.trim() === "") modelProvider.email = null;
      if (modelProvider.alterPhone?.trim() === "") modelProvider.alterPhone = null;
      if (modelProvider.observation?.trim() === "") modelProvider.observation = null;

      if (!modelProvider.swExpirationDays) {
        this.formProvider.controls["expirationDays"].setValue(0);
        modelProvider.expirationDays = 0;
      }

      if (this.providerId == 0) {
        try {
          this.providerContract = await firstValueFrom(this.providerService.createProvider(modelProvider));
          this.providerId = this.providerContract.providerId;
          this.validateForm(this.providerContract);
          this.disableUpdateDocument = false;
          this.toastHandlerService.showToast(
            'success',
            'El proveedor fue creado exitosamente.'
          );
          this.location.replaceState(`/provider/register/${this.providerId}`);
        } catch (error) {
          this.updateFormState();
          this.disableNamesByTypePerson(this.formProvider.get("typePersonId")?.value);
          console.error('Error al crear proveedor:', error);
        }
      } else {
        this.providerContract.typeDocumentId = modelProvider.typeDocumentId;
        this.providerContract.digitVerification = modelProvider.digitVerification;
        this.providerContract.typePersonId = modelProvider.typePersonId;
        this.providerContract.names = modelProvider.names;
        this.providerContract.lastNames = modelProvider.lastNames;
        this.providerContract.businessName = modelProvider.businessName;
        this.providerContract.comercialName = modelProvider.comercialName;
        this.providerContract.address = modelProvider.address;
        this.providerContract.email = modelProvider.email;
        this.providerContract.phone = modelProvider.phone;
        this.providerContract.alterPhone = modelProvider.alterPhone;
        this.providerContract.departmentId = modelProvider.departmentId;
        this.providerContract.cityId = modelProvider.cityId;
        this.providerContract.active = modelProvider.active;
        this.providerContract.shopping = modelProvider.shopping;
        this.providerContract.subRent = modelProvider.subRent;
        this.providerContract.transport = modelProvider.transport;
        this.providerContract.rateDiscount = modelProvider.rateDiscount;
        this.providerContract.rateDiscount = modelProvider.rateDiscount;
        this.providerContract.swSimpleTaxRegime = modelProvider.swSimpleTaxRegime;
        this.providerContract.swIvaResponsible = modelProvider.swIvaResponsible;
        this.providerContract.swIvaRetainer = modelProvider.swIvaRetainer;
        this.providerContract.swDeclarant = modelProvider.swDeclarant;
        this.providerContract.swGreatContributor = modelProvider.swGreatContributor;
        this.providerContract.swSelfRetainer = modelProvider.swSelfRetainer;
        this.providerContract.swExpirationDays = modelProvider.swExpirationDays;
        this.providerContract.expirationDays = modelProvider.expirationDays;
        this.providerContract.currencyId = modelProvider.currencyId;
        this.providerContract.observation = modelProvider.observation;

        try {
          this.providerContract = await firstValueFrom(this.providerService.updateProvider(this.providerContract));
          this.validateForm(this.providerContract);
          this.toastHandlerService.showToast(
            'success',
            'El proveedor fue modificado exitosamente.'
          );
        } catch (error) {
          this.updateFormState();
          console.error('Error al actualizar el proveedor.', error);
          return;
        }
      }
      this.disableNamesByTypePerson(this.providerContract.typePersonId);
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      typeDocumentId: {
        required: 'El campo Tipo Documento es obligatorio.',
        min: 'Debes seleccionar un Tipo Documento válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El Dígito de Verificación es obligatorio.',
        min: 'El valor mínimo del Dígito de Verificación es 1.',
        max: 'El valor máximo del Dígito de Verificación es 9.'
      },
      typePersonId: {
        required: 'El campo Tipo Persona es obligatorio.',
        min: 'Debes seleccionar un Tipo Persona válido.'
      },
      names: {
        required: 'El campo Nombres es obligatorio.',
        maxlength: 'El campo Nombres no puede tener más de 75 caracteres.'
      },
      lastNames: {
        required: 'El campo Apellidos es obligatorio.',
        maxlength: 'El campo Apellidos no puede tener más de 75 caracteres.'
      },
      businessName: {
        required: 'El campo Razón Social es obligatorio.',
        maxlength: 'El campo Razón Social no puede tener más de 150 caracteres.'
      },
      comercialName: {
        maxlength: 'El campo Nombre Comercial no puede tener más de 100 caracteres.'
      },
      address: {
        required: 'El campo Dirección es obligatorio.',
        maxlength: 'El campo Dirección no puede tener más de 70 caracteres.'
      },
      email: {
        email: 'El Correo no es válido.',
        maxlength: 'El campo Correo no puede tener más de 250 caracteres.'
      },
      phone: {
        required: 'El campo Teléfono es obligatorio.',
        minlength: 'El campo Teléfono debe tener al menos 7 caracteres.',
        maxlength: 'El campo Teléfono no puede tener más de 15 caracteres.'
      },
      alterPhone: {
        minlength: 'El Teléfono Alterno debe tener al menos 7 caracteres.',
        maxlength: 'El Teléfono Alterno no puede tener más de 15 caracteres.'
      },
      observation: {
        maxlength: 'El campo Observación no puede tener más de 500 caracteres.'
      },
      rateDiscount: {
        min: 'La Tasa de Descuento no puede ser menor a 0.',
        max: 'La Tasa de Descuento no puede ser mayor a 100.0.'
      },
      expirationDays: {
        min: 'Los Días de Vencimiento no pueden ser negativos.',
        max: 'Los Días de Vencimiento no pueden ser mayores a 32.'
      }
    };

    Object.keys(controlMessages).forEach(control => {
      const formControl = this.formProvider.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async setCityDepartment(selectedItems: any) {
    const city = selectedItems[0];
    this.cityName = city.cityName;
    this.cityId = city.id;
    this.departmentName = city.departmentName;
    this.departmentId = city.departmentId;
    this.formProvider.controls["cityId"].patchValue(this.cityId);
    this.formProvider.controls["departmentId"].patchValue(this.departmentId);
  }

  updateInputsForSelectCityModal() {
    this.inputsForSelectCityModal$.next({
      headers: this.headersCitySelection,
      data: this.citySelectionData,
      filters: this.filtersCitySelection,
      showCheckbox: true,
      showRecover: true
    });
  }

  updateFormState() {
    if (this.providerContract.active) {
      this.disabledForm = false;
      this.disableUpdateDocument = false;
      setTimeout(() => {
        this.formProvider.enable();
        this.disableNamesByTypePerson(this.providerContract.typePersonId);
      }, 100);
    } else {
      this.disabledForm = true;
      this.disableUpdateDocument = true;
      setTimeout(() => this.formProvider.disable(), 100);
    }
    setTimeout(() => this.formControlStateService.setControlState(this.formProvider, ['typeDocumentId', 'document'], true), 100);
    setTimeout(() => this.formControlStateService.setControlState(this.formProvider, ['digitVerification'], false), 100);
  }

  validateForm(provider: ProviderModel) {
    this.formProvider = this.formBuilder.group({
      typeDocumentId: [provider.typeDocumentId, [Validators.required, Validators.min(1)]],
      document: [provider.document, [Validators.required, Validators.minLength(1), Validators.maxLength(15)]],
      digitVerification: [provider.digitVerification, [Validators.required]],
      typePersonId: [provider.typePersonId, [Validators.required, Validators.min(1)]],
      names: [provider.names, [Validators.required, Validators.maxLength(75)]],
      lastNames: [provider.lastNames, [Validators.required, Validators.maxLength(75)]],
      businessName: [provider.businessName, [Validators.required, Validators.maxLength(150)]],
      comercialName: [provider.comercialName, [Validators.maxLength(100)]],
      address: [provider.address, [Validators.required, Validators.maxLength(70)]],
      email: [provider.email, [Validators.maxLength(50), Validators.email]],
      phone: [provider.phone, [Validators.required, Validators.minLength(7), Validators.maxLength(15)]],
      alterPhone: [provider.alterPhone, [Validators.minLength(7), Validators.maxLength(15)]],
      departmentId: [],
      cityId: [],
      active: [provider.active],
      shopping: [provider.shopping],
      subRent: [provider.subRent],
      transport: [provider.transport],
      rateDiscount: [provider.rateDiscount.toFixed(2), [Validators.required, Validators.min(0), Validators.max(100)]],
      observation: [provider.observation, [Validators.maxLength(500)]],
      swSimpleTaxRegime: [provider.swSimpleTaxRegime],
      swIvaResponsible: [provider.swIvaResponsible],
      swGreatContributor: [provider.swGreatContributor],
      swIvaRetainer: [provider.swIvaRetainer],
      swDeclarant: [provider.swDeclarant],
      swSelfRetainer: [provider.swSelfRetainer],
      swExpirationDays: [provider.swExpirationDays, []],
      expirationDays: [provider.expirationDays, [Validators.min(0), Validators.max(32767)]],
      currencyId: [provider.currencyId]
    });
    this.updateFormState();
    this.changeIvaResponsible();
    if (provider.providerId !== 0) {
      this.providerId = provider.providerId;
      this.cityId = provider.cityId;
      this.departmentId = provider.departmentId;
      this.getCityDepartment(provider.cityId);
      this.inputsForChangeDocumentModals$.next({ providerId: provider.providerId });
      setTimeout(() => this.formProvider.controls["active"].enable(), 100);
    } else {
      this.cityId = 0;
      this.departmentId = 0;
      this.cityName = '';
      this.departmentName = '';
      setTimeout(() => this.formProvider.controls["active"].disable(), 100);
    }
  }
}
